<template>
  <div>
  <div class='goods_discuss_wrapper'>
   <div class='goods_discuss_name_wrapper'>
     <div class='goods_discuss_name'>宝贝评价（348）</div>
     <div class='goods_discuss_more'>
       <button class='goods_discuss_more_btn'>查看全部评价<span class='icon-before icon-before_circle'></span></button>
     </div>
   </div>
   <div class='goods_discuss_des'>
     <div class='goods_discuss_des_btn'>穿着效果不错(63)</div><div class='goods_discuss_des_btn'>快递不错(63)</div><div class='goods_discuss_des_btn'>鞋子不错不错(63)</div>
   </div>
   <div class='goods_discuss_list'>
     <div class='goods_discuss_list_name_wrapper'>
         <img src='http://img.alicdn.com/tfscom/i1/2791921716/TB14EN0eiMnBKNjSZFCXXX0KFXa_!!0-item_pic.jpg' class='goods_discuss_pic' /><span>挑贵的买</span>
     </div>
     <div class='goods_discuss_content_wrapper'>
     今天收到衣服了，棉苗很好，很喜欢，颜色团和店家描述的一样手感舒适，
大小也适合，比较满意的一次购物，赞！
     </div>
   </div>
  </div>
</div>
</template>
<script type = "text/ecamscript-6">
export default {
  name:"commentList",
}
</script>
<style lang="stylus">
  .goods_discuss_wrapper
    margin-top:10px
    padding: 20px 30px
    background: #fff
    width: 100%
    margin-top: 10px
    box-sizing: border-box
    .goods_discuss_name_wrapper
      display: flex
      justify-content: space-between
      .goods_discuss_name
        font-size: 24px
        color: #666
        line-height: 30px
      .goods_discuss_more_btn
        color: #ff7400
        font-size: 22px
        line-height: 30px
        .icon-before_circle
          width: 24px
          height: 24px
          background: #ff7400
          text-align: center
          line-height: 24px
          color: #fff
          border-radius: 12px
          margin-left: 5px
    .goods_discuss_des
      padding-top: 25px
      font-size:0px
      .goods_discuss_des_btn
        padding: 0 25px
        height: 50px
        border-radius: 25px
        background: #ffedea
        color: #333
        display: inline-block
        margin-right: 15px
        font-size: 20px
        line-height: 50px
        margin-bottom:15px
    .goods_discuss_list
      margin-top:15px
      .goods_discuss_list_name_wrapper
        line-height: 46px
        vertical-align: middle
        font-size: 20px
        color: #666
        .goods_discuss_pic
          width: 46px
          height: 46px
          border-radius: 25px
          vertical-align: middle
          margin-right: 10px
      .goods_discuss_content_wrapper
        font-size: 20px
        color: #333
        line-height: 35px
        margin-top: 15px



  </style>



// WEBPACK FOOTER //
// src/components/item/commentList.vue